import { useEffect, useState } from "react";
import { fetchMyOrganisationSummary } from "../../../Moduels/attendance/attendanceApi";

export function useLeaveOrg() {
  const [orgId, setOrgId] = useState("");
  const [orgName, setOrgName] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const org = await fetchMyOrganisationSummary();
        if (!cancelled) {
          setOrgId(org?.id || org?.organisation_id || "");
          setOrgName(org?.name || org?.legal_name || "");
        }
      } catch {
        if (!cancelled) {
          setOrgId("");
          setOrgName("");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { orgId, orgName, loading };
}
